import { render } from "./WisdomExamRegistrationsList.vue?vue&type=template&id=5cf53de0&scoped=true"
import script from "./WisdomExamRegistrationsList.vue?vue&type=script&lang=js"
export * from "./WisdomExamRegistrationsList.vue?vue&type=script&lang=js"

import "./WisdomExamRegistrationsList.vue?vue&type=style&index=0&id=5cf53de0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf53de0"]])

export default __exports__